import {
  AnimatedContainer,
  Box,
  ContentContainer,
  LoadingIndicator,
  QueryErrorAlert
} from 'components';
import { useGetCodebooksQuery } from 'pages/settings/codebooks/queries';
import { useGetUsersQuery } from 'pages/settings/users/queries';
import React, { useCallback } from 'react';

import { useGetCompanyStatisticsQuery, useGetMainStatisticsQuery } from '../queries';
import CalendarChart from './CalendarChart';
import StatisticsCharts from './StatisticsCharts';

const ManagerDashboard: React.FC = (): React.ReactElement => {
  const codebooksQuery = useGetCodebooksQuery();
  const usersQuery = useGetUsersQuery();
  const companyStatisticsQuery = useGetCompanyStatisticsQuery();
  const mainStatisticsQuery = useGetMainStatisticsQuery();

  const isLoading =
    companyStatisticsQuery.isLoading ||
    mainStatisticsQuery.isLoading ||
    codebooksQuery.isLoading ||
    usersQuery.isLoading;

  const error =
    companyStatisticsQuery.error ||
    mainStatisticsQuery.error ||
    codebooksQuery.error ||
    usersQuery.error;

  const fetch = useCallback(async () => {
    codebooksQuery.error && (await codebooksQuery.refetch());
    usersQuery.error && (await usersQuery.refetch());
  }, [codebooksQuery, usersQuery]);

  return (
    <AnimatedContainer>
      <ContentContainer>
        {error && <QueryErrorAlert error={error} onRetry={() => fetch()} />}
        <StatisticsCharts
          users={usersQuery.data || []}
          orderCategories={codebooksQuery.data?.orderCategories || []}
          data={mainStatisticsQuery.data}
          isLoading={isLoading}
        />
        <Box>
          {companyStatisticsQuery.isFetching ? (
            <LoadingIndicator />
          ) : (
            <CalendarChart data={companyStatisticsQuery.data} />
          )}
        </Box>
      </ContentContainer>
    </AnimatedContainer>
  );
};

export default ManagerDashboard;
